import { render, staticRenderFns } from "./TodayBedOverview.vue?vue&type=template&id=2c7bb5bf&scoped=true&"
import script from "./TodayBedOverview.vue?vue&type=script&lang=js&"
export * from "./TodayBedOverview.vue?vue&type=script&lang=js&"
import style0 from "./TodayBedOverview.vue?vue&type=style&index=0&id=2c7bb5bf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7bb5bf",
  null
  
)

export default component.exports